"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_EN_TRANS = {
    'time picker': 'Time Picker',
    'today': 'Today',
    'set time': 'Set Time',
    'close': 'Close',
    'confirm': 'Confirm',
    'hour': 'Hour',
    'minute': 'Minute',
    'second': 'Second',
};
//# sourceMappingURL=en.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/ng2-date-time-picker/locale/en.js
// module id = ../../../../ng2-date-time-picker/locale/en.js
// module chunks = 4